import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { showPositionError } from '../helper/utils/error';
import { getGlobal } from '../helper/utils/globalize';
import { CONFIG_URL } from '../config';
import { sendRequest } from '../helper/utils/request';
/**
 * 获取地理位置
 * @param {*} timeout 超时时间
 * @param {*} maximumAge
 * @returns
 */

export var asyncGetLocation = function asyncGetLocation(props) {
  return new _Promise(function (resolve, reject) {
    try {
      if (!navigator.geolocation || !getGlobal().navigator.geolocation) {
        return reject({
          code: 0
        });
      }

      window.asyncGetLocationReject = reject;
      var location_timeout = setTimeout('asyncGetLocationReject()', 5000); //解决timeout无回调的情况

      navigator.geolocation.getCurrentPosition(function () {}, function () {}, {});
      navigator.geolocation.getCurrentPosition(function (position) {
        clearTimeout(location_timeout);
        resolve(position);
      }, reject, {
        timeout: props.timeout,
        maximumAge: props.maximumAge
      });
    } catch (e) {
      // console.error(e)
      return reject({
        code: 0
      });
    }
  });
};
/**
 * 弹窗获取用户确认后获取地理位置信息
 * @param {*} timeout 超时时间
 * @param {*} maximumAge
 * @returns
 */

export var getLocation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var props,
        position,
        _position$coords,
        _position$coords2,
        _position$coords3,
        _position$coords4,
        _position$coords5,
        _position$coords6,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
              timeout: 3000,
              maximumAge: 5000
            };
            position = {};
            _context.prev = 2;
            _context.next = 5;
            return asyncGetLocation(props);

          case 5:
            position = _context.sent;

            if (position && position.coords) {
              position = {
                a: ((_position$coords = position.coords) === null || _position$coords === void 0 ? void 0 : _position$coords.accuracy) || '',
                al: ((_position$coords2 = position.coords) === null || _position$coords2 === void 0 ? void 0 : _position$coords2.altitude) || '',
                la: ((_position$coords3 = position.coords) === null || _position$coords3 === void 0 ? void 0 : _position$coords3.latitude) || -0.0,
                lo: ((_position$coords4 = position.coords) === null || _position$coords4 === void 0 ? void 0 : _position$coords4.longitude) || -0.0,
                s: ((_position$coords5 = position.coords) === null || _position$coords5 === void 0 ? void 0 : _position$coords5.speed) || '',
                sa: ((_position$coords6 = position.coords) === null || _position$coords6 === void 0 ? void 0 : _position$coords6.speed_accuracy) || ''
              };
            }

            _context.next = 11;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

          case 11:
            return _context.abrupt("return", position);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));

  return function getLocation() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 获取服务端返回的ip信息
 * @param {*} values
 * @param {*} _config 用户配置
 * @returns
 */

export var getIpLocation = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, _config) {
    var res, ipLocation;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return sendRequest({
              url: _config.reportDevelopEnv ? CONFIG_URL.URL_LOCATION_DEVs : CONFIG_URL.URL_LOCATION_ONLINE,
              params: values,
              contentType: 'application/x-www-form-urlencoded'
            });

          case 2:
            res = _context2.sent;
            ipLocation = {
              ip_time_zone: '',
              ip_longitude: -0,
              ip_latitude: -0
            };

            if (res !== undefined) {
              if (_typeof(res) !== 'object') res = JSON.parse(res);
              res.success ? ipLocation = {
                ip_time_zone: res.data.ip_time_zone,
                ip_longitude: res.data.ip_longitude,
                ip_latitude: res.data.ip_latitude
              } : console.error('getIpLocation is error, code:-1');
            } else console.error('getIpLocation is error, code:-0');

            return _context2.abrupt("return", ipLocation);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getIpLocation(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();